import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { ExpenditureBudgetPurposeForm } from './ExpenditureBudgetPurposeForm';

type Props = ComponentProps<typeof ExpenditureBudgetPurposeForm>;

export const ExpenditureBudgetPurposeFormDrawer: FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { drawerState, setDrawerState } = useDrawerState();
  return (
    <Drawer
      open={
        drawerState.open && drawerState.type === 'expenditure-budget-purpose'
      }
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      <ExpenditureBudgetPurposeForm
        initialValues={initialValues}
        onSubmit={onSubmit}
      />
    </Drawer>
  );
};
